const dietduration = {
  getlist: 'dietduration/getlist',
  add: 'dietduration/add',
  update: 'dietduration/update',
  remove: 'dietduration/remove',
  get: 'dietduration/get',
  getall: 'dietduration/getall',
}
export default dietduration
